import { BRAND } from "@/data/site";

export default function MapEmbed({ height = 450 }) {
  return (
    <div
      data-testid="map-embed"
      className="relative rounded-2xl overflow-hidden border border-white/10 glass"
    >
      <iframe
        title="Star Otogaz Konum"
        src={BRAND.mapsEmbed}
        width="100%"
        height={height}
        style={{ border: 0 }}
        allowFullScreen
        loading="lazy"
        referrerPolicy="no-referrer-when-downgrade"
      />
    </div>
  );
}
